<script>
  import { VimeoPlayer } from 'svelte-vimeo-player'

  export let src
  let player
</script>

<div class="video">
  <VimeoPlayer
    videoId={src}
    bind:player={player}
    options={{
      responsive: true
    }}
  />
</div>

<style>
  .video {
    width: 100%;
  }
</style>